import React, { useRef, useState } from 'react';
import { Button } from '../../button/button';
import { IconCalendar } from '../../icon/icon';
import useOutsideClick from '../../../hooks/useOusideClick';
import { CalendarYear } from './calendarYear';
import { CalendarYearMonth } from './calendarYearMonth';

const dataInfo = {
  nomesDias: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  numeroSemanas: [1, 2, 3, 4, 5],
  numeroDiasSemana: [1, 2, 3, 4, 5, 6, 7],
  nomesMeses: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  nomesMesesAbv: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
};
//ESTE COMPONENTE FOI ALTERADO PARA CORRIGIR UM BUG
//NESTA NOVA FORMA, ELE É MENOS GENERALISTA (I.E. NÃO DEVE FUNCIONAR EM TODOS OS SISTEMAS)
//E CONSEQUENTEMENTE MENOS REAPROVEITÁVEL
//SE FARÁ NECESSÁRIA UMA REIMAGINAÇÃO PRINCIPALMENTE DO CÁLCULO DE POSIÇÃO

export function SelectCalendar({
  name,
  type = 'year',
  label = '',
  placeholder = 'Ano',
  action,
  selected,
  dataInicio,
  dataFim,
  yearsAvaliable,
  required,
  disabled,
  typeMont = 'abv',
  cy = '',
  withIcon = false,
}: any) {
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectCoordinates, setSelectCoordinates] = useState({});
  const ref = useRef(null);
  useOutsideClick(ref, (e: any) => {
    // openSelect({value: e})
    if (!e && selectOpen === true) {
      setSelectOpen(false);
    }
  });

  const openSelect = ({ elem, value }: any) => {
    if (elem) {
      let div = elem.target;
      let rect = div.getBoundingClientRect(),
        eixoX = rect.left,
        eixoY = rect.top,
        width = rect.width,
        height = rect.height;
      let windowHeight = window.innerHeight;

      let coor = {};
      //VERSÃO MENOS GENERALISTA SEM O BUG
      if (rect.right < width * 2) {
        coor = { left: -6 };
      } else {
        coor = { right: -6 };
      }
      setSelectCoordinates({
        ...coor,
        position: 'absolute',
        minWidth: width,
        width: '280px',
        maxWidth: '280px',
      });

      /* VERSÃO MAIS 'GENERALISTA'. OCORRE UM BUG QUE A DIV FICA 'FIXA' NA TELA
    if (Math.ceil(eixoY + height) + 300 >= windowHeight) {
      coor = { left: eixoX, bottom: windowHeight - eixoY, top: 'auto' };
    } else {
      coor = { left: eixoX - 7, top: eixoY + height + 1 };
    }
    setSelectCoordinates({ ...coor, position: 'absolute', minWidth: width, width: 'auto', maxWidth: '280px' });
    */
    }
    setSelectOpen(!selectOpen);
  };

  const textButton = (e: any) => {
    if (selected) {
      if (type === 'yearMonth' && typeMont !== 'num') {
        let info = selected.split('-');
        return `${
          dataInfo[typeMont === 'abv' ? `nomesMesesAbv` : `nomesMeses`][
            Number(info[0]) - 1
          ]
        }-${Number(info[1])}`;
      } else {
        return selected;
      }
    } else {
      return placeholder;
    }
  };

  const typeContent = (e: any) => {
    switch (type) {
      case 'year':
        return (
          <CalendarYear
            cy={`${cy}SelectCalendarYear`}
            name={name}
            label={placeholder}
            action={(e: any) => {
              action(e);
              setSelectOpen(false);
            }}
            value={selected}
            dataInicio={dataInicio}
            dataFim={dataFim}
          />
        );
      case 'avaliableYears':
        return (
          <CalendarYear
            cy={`${cy}SelectCalendarAvailableYear`}
            years={yearsAvaliable}
            name={name}
            label={placeholder}
            action={(e: any) => {
              action(e);
              setSelectOpen(false);
            }}
            value={selected}
            dataInicio={dataInicio}
            dataFim={dataFim}
          />
        );
      case 'yearMonth':
        return (
          <CalendarYearMonth
            cy={`${cy}SelectCalendarYearMonth`}
            name={name}
            label={placeholder}
            action={(e: any) => {
              action(e);
              setSelectOpen(false);
            }}
            value={selected}
            dataInicio={dataInicio}
            dataFim={dataFim}
          />
        );
    }
  };

  const require = required ? Object.keys(required) : undefined;

  return (
    <div
      className={`form-box form-select-box calendar-box ${
        require && required && (required.erro[name] ? 'erro' : '')
      } `}
    >
      {label ? (
        <label
          className="label-input"
          htmlFor={`id-${name}`}
          data-cy={`SelectBoxLabel${name}${cy}`}
        >
          {require ? <span className="required-label">*</span> : ''} {label}
        </label>
      ) : null}
      <div>
        <Button
          className={`${withIcon ? 'input calendar' : 'select-selected'} ${
            selectOpen ? 'open' : ''
          }`}
          onClick={(e) =>
            openSelect({ elem: e, value: !disabled ? !selectOpen : false })
          }
          cy={`OpenSelectCalendar${cy}`}
        >
          {textButton(selected)}
          {withIcon && <IconCalendar cy="Input" />}
        </Button>
        {selectOpen ? (
          <div
            ref={ref}
            className={`select-box select-calendar-${name}`}
            style={selectCoordinates}
          >
            {typeContent(type)}
          </div>
        ) : (
          <></>
        )}
      </div>
      {required?.erro?.[name] ? (
        <span
          className="campo-obrigatorio"
          data-cy="MandatorySelectCalendaraFieldSpan"
        >
          {required.message}
        </span>
      ) : null}
    </div>
  );
}
